import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  private disabledFeatures: string[] = [];
  private loaded = false;
  private anonymousHttpClient: HttpClient;

  constructor(private handler: HttpBackend) {
    this.anonymousHttpClient = new HttpClient(handler);
  }

  load(): void {
    this.anonymousHttpClient.get<{ featuresDisabled: string }>(environment.apiUrl + '/setting/disabled-features')
      .subscribe(rsp => {
        this.disabledFeatures = rsp.featuresDisabled
          ? rsp.featuresDisabled.split(',').map(f => f.trim())
          : [];
        this.loaded = true;
      });
  }

  isDisabled(feature: string): boolean {
    return this.disabledFeatures.includes(feature);
  }

  isEnabled(feature: string): boolean {
    return !this.isDisabled(feature);
  }
}
